import { render, staticRenderFns } from "./CreateProcessTask.vue?vue&type=template&id=939c0f36&"
import script from "./CreateProcessTask.vue?vue&type=script&lang=js&"
export * from "./CreateProcessTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports